var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseNotification',{attrs:{"to":`/feed#${_vm.pm.message[0].created}`,"avatar":_vm.avatar,"prefix":`${_vm.name} ${_vm.$t('bell-icon:message')}`,"content":_vm.pm.message[0].content}})
}
var staticRenderFns = []

export { render, staticRenderFns }